import { render, staticRenderFns } from "./svipPopupInfoModal.vue?vue&type=template&id=45296eb0&scoped=true"
import script from "./svipPopupInfoModal.vue?vue&type=script&lang=ts"
export * from "./svipPopupInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./svipPopupInfoModal.vue?vue&type=style&index=0&id=45296eb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45296eb0",
  null
  
)

export default component.exports